export var WaveStatus;
(function (WaveStatus) {
    WaveStatus["Draft"] = "DRAFT";
    WaveStatus["Review"] = "REVIEW";
    WaveStatus["Approved"] = "APPROVED";
    WaveStatus["Archived"] = "ARCHIVED";
})(WaveStatus || (WaveStatus = {}));
export const ALL_WAVE_STATUSES = [
    WaveStatus.Draft,
    WaveStatus.Review,
    WaveStatus.Approved,
    WaveStatus.Archived,
];
export const WAVE_WORKFLOW_STATUSES = [
    WaveStatus.Draft,
    WaveStatus.Review,
    WaveStatus.Approved,
];
export var WaveRole;
(function (WaveRole) {
    WaveRole["Owner"] = "OWNER";
    WaveRole["Editor"] = "EDITOR";
    WaveRole["Commenter"] = "COMMENTER";
    WaveRole["Viewer"] = "VIEWER";
})(WaveRole || (WaveRole = {}));
export const WAVE_FORMAT_BLOCK_V1 = "block-v1";
export const WAVE_FORMAT_YJS_V1 = "yjs-v1";
/** AppSync `appendWaveOpsMeta.fn.js` — max base64 string length per op. */
export const WAVE_APPEND_OP_B64_MAX_CHARS = 2048;
export function exceedsWaveAppendOpB64Limit(b64) {
    return b64.length > WAVE_APPEND_OP_B64_MAX_CHARS;
}
export var WaveBlockKind;
(function (WaveBlockKind) {
    WaveBlockKind["Text"] = "TEXT";
    WaveBlockKind["Heading"] = "HEADING";
    WaveBlockKind["Decision"] = "DECISION";
    WaveBlockKind["Signoff"] = "SIGNOFF";
    WaveBlockKind["Poll"] = "POLL";
    WaveBlockKind["Task"] = "TASK";
    WaveBlockKind["TodoList"] = "TODO_LIST";
    WaveBlockKind["Gallery"] = "GALLERY";
    WaveBlockKind["TidePageRef"] = "TIDE_PAGE_REF";
    WaveBlockKind["DriftTodoRef"] = "DRIFT_TODO_REF";
    WaveBlockKind["ReefArticleRef"] = "REEF_ARTICLE_REF";
    WaveBlockKind["PulseDocRef"] = "PULSE_DOC_REF";
    WaveBlockKind["File"] = "FILE";
})(WaveBlockKind || (WaveBlockKind = {}));
/** Prefisso deterministico dello spazio riservato Open Seas (`open-sea:<sub>`). */
export const WAVE_OPEN_SEA_PREFIX = "open-sea:";
/** Label UI dello spazio riservato (id/prefisso `open-sea:` invariato). */
export const WAVE_OPEN_SEAS_LABEL = "Open Seas";
/** True se lo `spaceId` è un Open Seas (sandbox per-utente). */
export function isOpenSeaWaveSpaceId(spaceId) {
    return typeof spaceId === "string" && spaceId.startsWith(WAVE_OPEN_SEA_PREFIX);
}
/** True per gli spazi di sistema riservati (Open Seas): niente share/delete/rename. */
export function isReservedWaveSpace(space) {
    return space.reserved === true || isOpenSeaWaveSpaceId(space.spaceId);
}
/** Uno spazio è "condiviso" se ha più di un membro o è visibile all'org. */
export function isSharedWaveSpace(space) {
    if (isReservedWaveSpace(space))
        return false;
    return space.memberCount > 1 || space.visibility === "ORG";
}
/**
 * Titolo da mostrare in UI: gli spazi riservati usano sempre la label
 * "Open Seas" (rename cosmetico) indipendentemente dal titolo backend.
 */
export function waveSpaceDisplayTitle(space) {
    if (isReservedWaveSpace(space))
        return WAVE_OPEN_SEAS_LABEL;
    return space.title;
}
/** Gallery card key → editor header asset (`*.png` → `*-header.png`). */
export function waveHeaderS3KeyFromCardKey(cardS3Key) {
    const card = cardS3Key?.trim();
    if (!card)
        return null;
    if (/-header\.png$/i.test(card))
        return card;
    if (/\.png$/i.test(card))
        return card.replace(/\.png$/i, "-header.png");
    return null;
}
/** Stored cover dimensions (aligned with cloud `cover-png-resize.mjs`). */
export const WAVE_COVER_CARD_ASPECT = 3;
/** Card = center sub-crop of the source; doubled to 192×64 for finer gallery detail. */
export const WAVE_COVER_CARD_STORE_W = 192;
export const WAVE_COVER_CARD_STORE_H = 64;
export const WAVE_COVER_HEADER_ASPECT = 3;
/** Header banner — FULL 3:1 source frame at native res (1536×512) so the wide banner stays crisp; the 96×32 card is its center sub-crop. */
export const WAVE_COVER_HEADER_STORE_W = 1536;
export const WAVE_COVER_HEADER_STORE_H = 512;
/** Canonical header key for the current gallery card (`…png` → `…-header.png`). */
export function resolvedWaveHeaderS3Key(coverImageHeaderS3Key, coverImageS3Key) {
    const derived = waveHeaderS3KeyFromCardKey(coverImageS3Key);
    if (derived)
        return derived;
    const header = coverImageHeaderS3Key?.trim();
    return header || null;
}
/** Quick-reaction emoji palette for Yjs-backed comments (shared web + iOS). */
export const WAVE_REACTION_PALETTE = ["👍", "❤️", "😄", "🎉", "✅"];
export function parseWaveStatus(raw) {
    return Object.values(WaveStatus).includes(raw)
        ? raw
        : WaveStatus.Draft;
}
export function parseWaveRole(raw) {
    return Object.values(WaveRole).includes(raw)
        ? raw
        : WaveRole.Viewer;
}
